import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root'
})
export class IndodanaService {

    constructor(private httpClient:HttpClient){}

    public validationPayment(refNumber:string){
        return this.httpClient.get(environment.apiUrl+"indodana/generate-order/"+refNumber);
    }

    public submitPayment(data:any){
        return this.httpClient.post(environment.apiUrl+"indodana/payment", data);
    }
}